import type { Messages } from "../types";

export const hu = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exkluzív keresztény társkereső",
    "continue": "Folytatás",
    "leave": "Kilépés",
    "leaveForNow": "Egyelőre kilépek",
    "yes": "Igen",
    "no": "Nem",
    "goBack": "Vissza",
    "saving": "Mentés…",
    "submitting": "Küldés…",
    "pleaseWait": "Kérjük, várjon…",
    "ellipsis": "…",
    "male": "Férfi",
    "female": "Nő",
    "phases": {
      "gate": "Kapu",
      "verify": "Ellenőrzés",
      "setup": "Beállítás",
      "profile": "Profil"
    },
    "storageQuota": "Ezen a telefonon nincs elég hely a mentett válaszokhoz. Szabadíts fel tárhelyet, majd próbáld újra.",
    "storageDisabled": "Ez a böngésző nem menti a válaszaidat. Kapcsold ki a privát módot, vagy engedélyezd az oldaladatokat, majd töltsd újra.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min. {min} karakter"
  },
  "welcome": {
    "promise": "A célunk, hogy a lehető leghamarabb töröld ezt az alkalmazást.",
    "sub": "A UN8 komoly keresztény egyedülállóknak segít életársat találni — majd elmenni. Ellenőrizve. Értékek először. Nincs végtelen swipelés.",
    "signedInAs": "Bejelentkezve: {email}",
    "liveServer": " · élő szerver",
    "deviceOnly": " · csak ezen az eszközön",
    "migrateOffer": "Ezen az eszközön még van helyi profil. Feltöltöd a megosztott szerverre, hogy más telefonok is lássanak moderáció után? Semmi sem töltődik fel, amíg nem választasz.",
    "uploadLocalProfile": "Helyi profil feltöltése",
    "keepOnDevice": "Csak ezen az eszközön maradjon",
    "migrateNeedGender": "Először válaszd a profilban a Férfi vagy Nő lehetőséget.",
    "migrateDone": "A profilszöveg feltöltve. Töltsd fel újra az igazolványt, a videót és a fotókat, hogy a moderáció átnézhesse őket.",
    "deleteConfirm": "Véglegesen töröljük a fiókodat, az összes üzenetet és az összes médiát (beleértve az igazolványt és a videót) a szerverről?",
    "accountDeleted": "Fiók törölve.",
    "begin": "Kezdés",
    "continueOnboarding": "Regisztráció folytatása",
    "logIn": "Bejelentkezés",
    "logOut": "Kijelentkezés",
    "reviewConsole": "Ellenőrző konzol",
    "matching": "Párosítás",
    "deleteMyAccount": "Fiókom törlése"
  },
  "faith": {
    "eyebrow": "Hitkapu",
    "title": "Csak keresztények",
    "text": "A UN8 Jézus Krisztus követőinek közössége, olyan tagoknak, akik házasságra törekvő partnert keresnek, aki ugyanazt a hitet vallja. Ezt a kaput nem lehet kihagyni.",
    "yesTitle": "Keresztény vagyok",
    "yesBody": "Jézus Krisztust követem, és házasságra törekvő partnert keresek, aki osztja ezt a hitet.",
    "noTitle": "Nem vagyok keresztény",
    "noBody": "A UN8 nem az én helyem — és ez rendben van.",
    "respectTitle": "Tisztelettel",
    "respectBody": "A UN8 egy közösségnek készült, és inkább őszinték vagyunk, mint hogy elpazaroljuk az idődet. Használd alább a Kilépést, vagy a Visszát, ha ez nem a te otthonod.",
    "sharedTitle": "Közös alap",
    "sharedBody": "A hit itt nem címke. Az a talaj, amelyen találkoztok.",
    "hintNotChristian": "A UN8 Jézus Krisztus követőinek szól. Koppints alább a Kilépésre, vagy válaszd a keresztény lehetőséget, ha az vagy.",
    "hintUnset": "Koppints a „Keresztény vagyok” gombra a folytatáshoz, vagy Kilépés / Vissza, ha ez nem a te otthonod."
  },
  "rules": {
    "eyebrow": "Közösségi szövetség",
    "title": "Hogyan bánunk egymással",
    "text": "Erősíts meg minden szabályt. Mindhárom kötelező. A megsértésük végleges eltávolításhoz vezet. A hamis profilok örökre tiltva vannak.",
    "agreeContinue": "Egyetértek — folytatás",
    "respectful": {
      "title": "Légy tisztelettudó",
      "description": "Beszélj és cselekedj méltósággal. Mindenki itt Isten képmására teremtetett."
    },
    "noSexualContent": {
      "title": "Nincs szexuális tartalom",
      "description": "Nincs explicit fotó, üzenet vagy kérés. A tisztaság itt nem opcionális."
    },
    "noDominance": {
      "title": "Ne uralkodj és ne kontrollálj",
      "description": "Nincs kényszer, manipuláció vagy nyomás. A szeretet nem uralkodik."
    },
    "hint": "Jelöld be mindhárom ígéretet, mielőtt folytatod."
  },
  "intent": {
    "eyebrow": "",
    "title": "Mit keresel?",
    "text": "",
    "marriage": {
      "label": "Élettársat",
      "description": ""
    },
    "discernment": {
      "label": "Komoly megkülönböztetés",
      "description": ""
    },
    "notCasual": {
      "label": "Semmi laza",
      "description": ""
    },
    "hint": "Válassz egyet."
  },
  "account": {
    "eyebrow": "Fiók",
    "title": "Hozd létre a hozzáférésedet",
    "text": "A handle stabil felhasználói azonosítót hoz létre. A jelentkezés, az ellenőrzés, a kedvelések és a párok mind ehhez az azonosítóhoz kötődnek. Nem küldünk e-mailt.",
    "recoveryTitle": "Mentsd el a helyreállító kódodat",
    "recoveryText": "Csak egyszer jelenik meg. Enélkül elveszett jelszóval ebben a zárt tesztben nem lehet visszaállítani.",
    "savedContinue": "Elmentettem — folytatás",
    "handle": "Handle",
    "handlePlaceholder": "te@pelda.com vagy rövid handle",
    "passphrase": "Jelszó",
    "passphrasePlaceholder": "Legalább 8 karakter",
    "signedInTitle": "Bejelentkezve",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Bizalmi szabvány",
    "trustBody": "Egyetlen profil sem látható, amíg a személyazonosság-ellenőrzés kész nincs, és a moderáció jóvá nem hagy.",
    "continueToVerification": "Tovább az ellenőrzéshez",
    "hintEmail": "Írj be egy e-mail-címet, amely tartalmazza a @ jelet.",
    "hintPassword": "Válassz legalább 8 karakteres jelszót."
  },
  "verify": {
    "intro": {
      "eyebrow": "Ellenőrzés",
      "title": "A bizalom a kapu",
      "text": "Tölts fel kormányzati igazolványt, megerősítő videót és {min}–{max} valódi fotót. Minden a bírálati sorba kerül, mielőtt a profilod megjelenhet.",
      "whyTitle": "Miért ellenőrzünk",
      "whyBody": "A catfishingnek és a féligazságoknak itt nincs helye. A hamis profilok véglegesen tiltva vannak. A média pending_review státusszal tárolódik, amíg jóvá nem hagyják.",
      "start": "Ellenőrzés indítása"
    },
    "steps": {
      "id": {
        "title": "Kormányzati igazolvány",
        "description": "Útlevél vagy személyi — kamera vagy fájlfeltöltés."
      },
      "video": {
        "title": "Megerősítő videó",
        "description": "Rövid felvétel, amely bizonyítja, hogy jelen vagy."
      },
      "photos": {
        "title": "Valódi fotók",
        "description": "Hét–tíz tiszta fotó magadról."
      },
      "review": {
        "title": "Integritás-ellenőrzés",
        "description": "A feltöltések pending_review állapotban maradnak, amíg a stáb meg nem erősíti."
      }
    },
    "id": {
      "eyebrow": "1. lépés / 4",
      "title": "Kormányzati igazolvány",
      "text": "Készíts vagy tölts fel útlevélről vagy személyiről. Semmi sem kerül nyilvánosságra — a státusz pending_review marad, amíg a stáb meg nem erősíti.",
      "savedTitle": "Igazolvány mentve",
      "savedBody": "Következik egy rövid megerősítő videó az arcodról, majd 7–10 valódi fotó magadról. A folytatás akkor oldódik fel, amikor ez az igazolvány mentettként jelenik meg.",
      "hint": "Készíts vagy tölts fel fotót a kormányzati igazolványodról, majd várj, amíg mentettnek jelzi."
    },
    "video": {
      "eyebrow": "2. lépés / 4",
      "title": "Megerősítő videó",
      "text": "Vegyél fel egy rövid klippet, vagy tölts fel egyet. Nézz a kamerába. Beszélj tisztán. Ez bizonyítja, hogy jelen vagy — nem egy lescrapelt galéria.",
      "hint": "Vegyél fel egy rövid megerősítő videót, majd várj, amíg mentettnek jelzi."
    },
    "photos": {
      "eyebrow": "3. lépés / 4",
      "title": "Valódi fotók",
      "text": "Adj hozzá {min}–10 friss fotót magadról. Használd a kamerát vagy a könyvtárat. Koppints a ×-re bármelyik kép eltávolításához.",
      "continueToReview": "Tovább az ellenőrzéshez",
      "hint": "Adj hozzá {min}–10 tiszta fotót magadról. A folytatás akkor oldódik fel, amikor mentve vannak."
    },
    "review": {
      "eyebrow": "4. lépés / 4",
      "title": "Integritás-ellenőrzés",
      "text": "A média pending_review{underUser} sorba kerül. A párok és kedvelések ugyanezt az azonosítót használják.",
      "underUser": " a(z) {userId} felhasználó alatt",
      "governmentId": "Kormányzati igazolvány",
      "confirmationVideo": "Megerősítő videó",
      "photos": "Fotók",
      "missing": "Hiányzik",
      "filesReady": "{count} fájl kész",
      "submittedTitle": "Bírálatra benyújtva",
      "submittedText": "A jelentkezési azonosító egyenlő az auth felhasználói azonosítóval, így a jóváhagyás → pool és a kölcsönös kedvelések egy vonalon maradnak.",
      "submitContinue": "Beküldés és folytatás"
    }
  },
  "setup": {
    "eyebrow": "Fiókbeállítás",
    "title": "Mondj igazat magadról",
    "text": "Ezek a válaszok alakítják a párosítást, és megjelennek az ellenőrzésben. A lágy hazugságok mindenki idejét pazarolják — a tiédet is.",
    "beginSetup": "Beállítás indítása",
    "pillars": {
      "faith": {
        "name": "Hit",
        "text": "Miért követed Krisztust."
      },
      "character": {
        "name": "Jellem",
        "text": "Hűség, őszinteség, szenvedély, elkötelezettség — 1–10-ig."
      },
      "story": {
        "name": "Történet",
        "text": "Ki vagy, és mit keresel."
      },
      "life": {
        "name": "Élet",
        "text": "Hobbi, olvasás és hivatás."
      }
    },
    "whyChristian": {
      "eyebrow": "Hit",
      "title": "Miért vagy keresztény?",
      "text": "Rövid, őszinte válasz. Nem prédikáció — egy ok, ami a tied.",
      "label": "A válaszod",
      "placeholder": "pl. Krisztussal egy veszteség időszakában találkoztam, és azóta követem Őt…",
      "hint": "Írj legalább {min} karaktert arról, miért követed Jézust."
    }
  },
  "scales": {
    "eyebrow": "Jellem-skálák",
    "title": "Értékeld magad őszintén",
    "text": "Hűség, őszinteség, szenvedély, elkötelezettség — mindegyik 1-től 10-ig. A felfújt számok később csak rossz párosítást hoznak. Minden skálát be kell állítanod a folytatáshoz.",
    "loyalty": {
      "label": "Hűség szintje",
      "hint": "Légy őszinte — milyen hűségesen állsz azok mellett, akiket szeretsz?"
    },
    "honesty": {
      "label": "Őszinteség szintje",
      "hint": "Milyen következetesen mondod el a teljes igazságot?"
    },
    "passion": {
      "label": "Mennyire vagy szenvedélyes?",
      "hint": "Meggyőződés és mélység — nem előadás."
    },
    "commitment": {
      "label": "Elkötelezettség szintje",
      "hint": "Mennyire vagy kész tartósat építeni?"
    },
    "hint": "Mozgasd minden csúszkát, amíg szám jelenik meg — egyik sem maradhat kötőjel."
  },
  "about": {
    "eyebrow": "Rólad",
    "title": "Írj magadról néhány mondatot",
    "text": "Ki vagy, amikor senki sem játszik szerepet. Temperamentum, ritmus, ami a mindennapokban számít.",
    "label": "Rólad",
    "placeholder": "Csendes reggelek, komolyan a családról, könnyen nevetek, a mélységet részesítem előnyben a zajjal szemben…",
    "hint": "Írj magadról legalább {min} karaktert."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Mit keresel?",
    "text": "A fő jellemvonások, amelyeket egy lehetséges partnerben kívánsz — nem külsejű bevásárlólista.",
    "label": "Kívánt jellemvonások",
    "placeholder": "pl. Állhatatos hit, érzelmi érettség, kedvesség stressz alatt…",
    "hint": "Írj legalább {min} karaktert arról a partnerről, akit remélsz."
  },
  "loveReady": {
    "eyebrow": "Küszöb",
    "title": "Készen állsz megismerni életed szerelmét?",
    "text": "A UN8 azért van, hogy a komoly egyedülállók partnert találjanak — majd töröljék az alkalmazást. Csak az „Igen” oldja fel a folytatást.",
    "yesTitle": "Igen — készen állok",
    "yesBody": "Azért vagyok itt, hogy világossággal és bátorsággal találkozzak a párommal.",
    "noTitle": "Még nem",
    "noBody": "Ha csak böngészöl, ez a közösség nem a megfelelő.",
    "comeBackTitle": "Gyere vissza, amikor készen állsz",
    "comeBackBody": "A UN8 azoknak szól, akik készen állnak találkozni — nem opciókat gyűjteni. Használd alább a Kilépést, ha most megállnál. A válaszaid ezen a telefonon mentve vannak.",
    "hintNo": "Csak az „Igen” folytat. Ha nem állsz készen, koppints az Egyelőre kilépek gombra — a válaszaid ezen a telefonon maradnak.",
    "hintUnset": "Koppints az Igenre, ha készen állsz házasságra törekvő találkozásra."
  },
  "lifestyle": {
    "eyebrow": "Életmód",
    "title": "Hogyan élsz nap mint nap",
    "text": "Sport, hobbi, olvasás és szakma — gyakorlati jelek a valódi kompatibilitáshoz.",
    "hobbies": "Jelenlegi sportok vagy hobbik",
    "hobbiesPlaceholder": "Amit aktívan csinálsz — nem amit egyszer régen.",
    "reading": "Olvasol?",
    "readingHint": "1 = szinte soha · 10 = napi, mély olvasás",
    "profession": "Szakma / ágazat",
    "professionPlaceholder": "pl. Ápolás · Szoftver · Oktatás · Szakmák",
    "hintHobbies": "Nevezz meg legalább egy sportot vagy hobbit, amit tényleg csinálsz.",
    "hintReading": "Csúsztasd az „Olvasol?” skálát, amíg 1 és 10 közötti szám jelenik meg.",
    "hintProfession": "Írd be a munkádat, akár egy rövid szóval is."
  },
  "faithDepth": {
    "eyebrow": "Párosítás · Hit",
    "title": "Mennyire központi a hited?",
    "text": "Isten szolgálata — mennyire fontos az életedben? Válaszolj őszintén. A párosítás ezt a mélységhez használja, nem az előadáshoz.",
    "serving": "Isten szolgálata — fontosság",
    "servingHint": "10% … 100%. Csúsztasd 10-es lépésekben.",
    "keepsCommandments": "Megtartod a parancsolatokat?",
    "grewUpInChurch": "Egyházban nőttél fel?",
    "churchAttendance": "Templomi részvétel",
    "frequent": {
      "label": "Gyakori",
      "hint": "Rendszeres gyülekezés Krisztus testével."
    },
    "seldom": {
      "label": "Ritkán",
      "hint": "Alkalmanként, nem heti ritmus."
    },
    "never": {
      "label": "Soha",
      "hint": "Jelenleg nem járok."
    },
    "spreadsGospel": "Terjeszted az evangéliumot?",
    "hasIdols": "Vannak bálványaid?",
    "hintServing": "Csúsztasd, mennyire fontos Isten szolgálata az életedben.",
    "hintCommandments": "Válaszolj, megtartod-e a parancsolatokat — Igen vagy Nem.",
    "hintGrewUp": "Válaszolj, egyházban nőttél-e fel — Igen vagy Nem.",
    "hintAttendance": "Válaszd ki, milyen gyakran jársz templomba.",
    "hintGospel": "Válaszolj, megosztod-e az evangéliumot — Igen vagy Nem.",
    "hintIdols": "Válaszolj, vannak-e bálványaid — Igen vagy Nem."
  },
  "character": {
    "eyebrow": "Párosítás · Jellem",
    "title": "Ki vagy otthon",
    "text": "Jellem az udvarláshoz — béketeremtés, udvariasság, őszinteség. A felfújt válaszok később csak rossz párosítást hoznak.",
    "peacemaker": "Béketeremtő vagy?",
    "homebuilder": "Otthonépítő vagy?",
    "humorous": "Humoros vagy?",
    "caring": "Gondoskodó és szeretetteljes?",
    "peacefulHome": "Békés otthont szeretnél — veszekedés nélkül?",
    "manners": "Jó modor?",
    "honestyRating": "Őszinteség értékelése ezen a kérdőíven",
    "honestyHint": "1–10 — milyen őszintén válaszolsz?",
    "hintPeacemaker": "Válaszolj mindenre Igen vagy Nem, kezdve a béketeremtővel.",
    "hintHomebuilder": "Válaszolj, otthonépítő vagy-e.",
    "hintHumorous": "Válaszolj, humoros vagy-e.",
    "hintCaring": "Válaszolj, gondoskodó és szeretetteljes vagy-e.",
    "hintPeaceful": "Válaszolj, békés otthont szeretnél-e.",
    "hintManners": "Válaszolj, van-e jó modorod.",
    "hintHonesty": "Csúsztasd az őszinteség értékelésedet 1-től 10-ig."
  },
  "history": {
    "eyebrow": "Párosítás · Múlt",
    "title": "Múlt és készenlét",
    "text": "Szerek, gyermekkor, hegek, és hogy készen állsz-e tartós kapcsolatra. Az igazság itt mindkettőtöket védi.",
    "marijuana": "Használtál marihuánát?",
    "lsd": "Használtál LSD-t?",
    "otherDrugs": "Használtál más drogokat?",
    "addicted": "Voltál függő?",
    "childhood": "Stabil, szerető gyermekkor?",
    "scars": "Vannak hegek / sérülések?",
    "lasting": "Készen állsz tartós kapcsolatra?",
    "hintStart": "Válaszolj minden Igen vagy Nem kérdésre ezen az oldalon, felülről kezdve.",
    "hintLsd": "Válaszolj az LSD kérdésre — Igen vagy Nem.",
    "hintOtherDrugs": "Válaszolj, használtál-e más drogokat.",
    "hintAddicted": "Válaszolj, voltál-e függő.",
    "hintChildhood": "Válaszolj, stabil és szerető volt-e a gyermekkorod.",
    "hintScars": "Válaszolj, hordozol-e hegeket.",
    "hintLasting": "Válaszolj, készen állsz-e tartós kapcsolatra."
  },
  "appearance": {
    "eyebrow": "Párosítás · Külső",
    "title": "Tetoválások",
    "text": "A te tetoválásaid, és hogy a partneren lévő tetoválások elfogadhatók-e számodra.",
    "hasTattoos": "Vannak tetoválásaid?",
    "acceptsPartner": "Elfogadsz tetoválást a partneren?",
    "hintHas": "Mondd meg, vannak-e tetoválásaid — Igen vagy Nem.",
    "hintAccepts": "Mondd meg, elfogadhatók-e számodra a partner tetoválásai."
  },
  "home": {
    "eyebrow": "Párosítás · Otthon és föld",
    "title": "Föld, készségek, önellátás",
    "text": "Gyógynövények, élelmiszer-termesztés, gyümölcserdő, felkészülés, közösségi gazdálkodás, tartósítás, túlélés — és bármilyen különleges készség.",
    "herbKnowledge": "Gyógynövény-ismeret?",
    "plantOwn": "Ültetsz saját gyümölcsöt és zöldséget?",
    "fruitForest": "Érdekel a gyümölcserdő?",
    "prepping": "Felkészülsz katasztrófákra?",
    "communityFarming": "Közösségi gazdálkodás / független élet?",
    "canning": "Konzerválás és tartósítás?",
    "survival": "Túlélési készségek?",
    "specialSkills": "Különleges készségek (opcionális)",
    "specialPlaceholder": "Bármi más, amit egy háztartáshoz vagy földhöz hozol…",
    "hintStart": "Válaszolj minden Igen vagy Nem kérdésre a földről és a készségekről, felülről kezdve.",
    "hintPlant": "Válaszolj, ültetsz-e saját gyümölcsöt és zöldséget.",
    "hintFruitForest": "Válaszolj, érdekel-e a gyümölcserdő.",
    "hintPrepping": "Válaszolj, felkészülsz-e katasztrófákra.",
    "hintCommunity": "Válaszolj, érdekel-e a közösségi gazdálkodás.",
    "hintCanning": "Válaszolj, konzerválsz és tartósítasz-e ételt.",
    "hintSurvival": "Válaszolj, vannak-e túlélési készségeid."
  },
  "family": {
    "eyebrow": "Párosítás · Család",
    "title": "Gyermekek, hithűség, szerek",
    "text": "Amire szükséged van egy partnerben a hit intenzitása, a gyermekek és a korábbi szerhasználat tekintetében.",
    "children": "Gyermekek",
    "wants": {
      "label": "Gyermeket szeretne",
      "hint": "A családépítés része a látomásnak."
    },
    "doesNotWant": {
      "label": "Nem szeretne gyermeket",
      "hint": "Egyértelmű nem a gyermekekre."
    },
    "open": {
      "label": "Nyitott",
      "hint": "Megkülönböztetés — egyik irányba sem zárt."
    },
    "hasLivingWith": {
      "label": "Van gyermeke — együtt él velük",
      "hint": "A gyermekek már a mindennapok részei."
    },
    "requiredFaith": "Minimális hithűség, amire szükséged van a partnerben",
    "requiredFaithHint": "10% … 100%. Kemény kapu, ha mindkét fél válaszolt.",
    "acceptsSubstances": "Elfogadod a partner korábbi szerhasználatát?",
    "hintChildren": "Válassz egy kártyát a gyermekekről.",
    "hintFaith": "Csúsztasd a minimális hithűséget, amit a partnerben remélsz.",
    "hintSubstances": "Mondd meg, elfogadható-e a partner korábbi szerhasználata."
  },
  "ancestry": {
    "eyebrow": "Párosítás · Háttér",
    "title": "Háttérpreferenciák",
    "text": "Oszd meg a hátteredet, és hogy mire vagy nyitott egy partnerben. Ez csak a rangsort alakítja — soha nem rejti el senkit a pakliból.",
    "yourBackground": "A te háttered (jelöld az összeset, ami illik)",
    "openToPartner": "Nyitott a partnerben",
    "codeDesc": "Kód: {code}",
    "anyDesc": "A legerősebb preferencia a szélességre — ajánlott, ha bizonytalan vagy.",
    "preferenceOnly": "Csak preferencia — nem kapu.",
    "hintOwn": "Jelölj be legalább egy hátteret, amely leír téged. Ez csak a rangsorolást segíti — soha nem rejti el senkit.",
    "hintAccepted": "Jelöld, mire vagy nyitott egy partnerben, vagy „Nyitott — nincs preferencia”."
  },
  "interests": {
    "eyebrow": "Párosítás · Érdeklődés",
    "title": "Amit élvezel",
    "text": "Válassz legalább egyet. Az átfedés segíti a rangsort; a hallgatást soha nem büntetjük.",
    "hint": "Jelölj be legalább egy érdeklődést."
  },
  "reflection": {
    "eyebrow": "Párosítás · Elmélkedés",
    "title": "Saját szavaiddal",
    "text": "Ez a négy válasz teljes egészében megjelenik, és soha nincs pontozva. Írd le, ami igaz.",
    "describeYourself": "Írd le magad",
    "lifePurpose": "Életcél",
    "fifteenYear": "Te és életed szerelme 15 év múlva",
    "weaknesses": "Gyengeségek",
    "hintDescribe": "Írd le magad legalább {min} karakterben.",
    "hintPurpose": "Írd le az életcélodat legalább {min} karakterben.",
    "hintVision": "Írd le a 15 éves látomást legalább {min} karakterben.",
    "hintWeaknesses": "Nevezz meg egy gyengeséget legalább {min} karakterben."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Néhány alapvető",
    "text": "Tartsd egyszerűen. A nem itt bináris — férfi vagy nő — a tiszta párosításért.",
    "firstName": "Keresztnév",
    "firstNamePlaceholder": "Ahogyan ismertetni szeretnéd magad",
    "age": "Kor",
    "agePlaceholder": "18+",
    "city": "Város",
    "cityPlaceholder": "Hol vagy",
    "sex": "Nem",
    "maleBody": "Férfi vagyok.",
    "femaleBody": "Nő vagyok.",
    "hintName": "Írd be a keresztnevedet (legalább két betű).",
    "hintAge": "A kornak 18 vagy annál többnek kell lennie.",
    "hintCity": "Írd be a várost, ahol élsz.",
    "hintGender": "Válaszd a Férfi vagy Nő lehetőséget, hogy a párosítás működhessen."
  },
  "ready": {
    "title": "Beléphetsz.",
    "textNamed": "{name}, az ellenőrzésed és a beállításod rögzítve. A média pending_review. Üdv a UN8-ban — találd meg a párod, majd töröld az alkalmazást.",
    "text": "Az ellenőrzésed és a beállításod rögzítve. A média pending_review. Üdv a UN8-ban — találd meg a párod, majd töröld az alkalmazást.",
    "summaryAria": "Beállítás összefoglalója",
    "christianRules": "Keresztény · szabályok megerősítve",
    "mediaLine": "Igazolvány · videó · {photoCount} fotó · sor {pending}",
    "scalesLine": "Skálák L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Nem —",
    "professionFallback": "szakma",
    "userLine": "Felhasználó {userId}",
    "enterMatching": "Belépés a párosításba",
    "needGender": "Menj vissza a profil lépéshez, válaszd a Férfi vagy Nő lehetőséget, majd próbáld újra."
  },
  "match": {
    "brandTag": "Párosítás",
    "navOnboarding": "Regisztráció",
    "navReview": "Ellenőrzés",
    "navMatching": "Párosítás",
    "logOut": "Kijelentkezés",
    "enterTitle": "Belépés a párosításba",
    "enterText": "Jelentkezz be ugyanazzal az e-maillel, mint a regisztrációnál. A jelentkezés, a pool, a kedvelések és a párok mind a stabil felhasználói azonosítódat használják.",
    "email": "E-mail",
    "emailPlaceholder": "te@pelda.com",
    "password": "Jelszó",
    "passwordPlaceholder": "A jelszavad",
    "logIn": "Bejelentkezés",
    "guestOr": "Vagy próbálj vendég munkamenetet (stabil azonosító böngészőnként · csak demo)",
    "guestMan": "Vendég férfiként",
    "guestWoman": "Vendég nőként",
    "goOnboarding": "Tovább a regisztrációhoz →",
    "guestSession": "Vendég munkamenet · demo pool",
    "packTitle": "A négyed",
    "packSkip": "Koppints a folytatáshoz",
    "newSelection": "Új választás",
    "backToFour": "← Vissza a négyedhez",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "férfi",
    "woman": "nő",
    "navSelection": "Választás",
    "navMessages": "Üzenetek",
    "navProfile": "Profil",
    "tabToday": "Választás",
    "tabMatches": "Párok ({count})",
    "yourMatches": "A páraid",
    "matchesSub": "Tartós kölcsönös érdeklődés · {count} kimenő {likesWord}",
    "like": "kedvelés",
    "likes": "kedvelés",
    "emptyMatches": "Még nincs kölcsönös érdeklődés. Folytasd a heti választás megkülönböztetését.",
    "valuesScore": "Értékek {score}",
    "chatOpen": " · Chat nyitva",
    "tapToChat": " · Koppints a chatre",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Értékek {score}",
    "noProfileYet": "Még nincs profil",
    "noProfileText": "Fejezd be a regisztrációt, vagy koppints felül a Regisztrációra, majd a Kezdésre. A vendégpárosítás a belépő képernyőn van, ha csak nézelődni szeretnél.",
    "matchingPaused": "Párosítás szünetel",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Még nincs kit mutatni",
    "todaysSetDone": "Ez a heti választás",
    "weeklyTitle": "A heti 4-ed",
    "weeklyTitleCount": "A heti {count}-ed",
    "weeklyCountdown": "Következő választás {days} nap múlva",
    "weeklyCountdownOne": "Következő választás 1 nap múlva",
    "weeklyCountdownSoon": "Következő választás hamarosan",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Ez a heti választás",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "A heti listán még senki nincs. A pool töltődik — nyisd meg a Választást mindjárt, vagy gyere vissza, ha több tagot jóváhagytunk.",
    "emptyDone": "Végigmentél a heti választáson. Gyere vissza a következő nyitáskor, vagy állítsd vissza a paklit.",
    "likesMayNotStick": " A kedvelések lehet, hogy nem maradnak meg.",
    "poolMeta": "Pool: {pool} · Párok: {matches} · Kedvelt: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Pakli visszaállítása",
    "backOnboarding": "Vissza a regisztrációhoz",
    "feedEyebrowDemo": "Heti választás · Demó",
    "feedEyebrowLive": "Heti választás · Pool ({source}, {count})",
    "feedTitle": "Figyelemmel különböztess",
    "left": "még {count}",
    "pass": "Átugrás",
    "interested": "Érdekel",
    "swipeHint": "Csúsztass vagy használd a gombokat. A pár csak akkor nyílik meg, ha az érdeklődés kölcsönös és tartós.",
    "celebrationEyebrow": "Kölcsönös érdeklődés",
    "celebrationTitle": "Összepárosodtatok",
    "celebrationText": "{self} és {other} mindketten érdeklődést mutattak. Értékegyezés: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "A chat feloldva ehhez a párhoz. Maradj tisztelettudó — szövetség a kényelem felett.",
    "openChat": "Chat megnyitása",
    "keepDiscerning": "Tovább különböztetni",
    "cardSeeking": "Keres",
    "cardHobbies": "Hobbi",
    "affinity": "Affinitás",
    "valuesScoreLabel": "Értékpontszám",
    "scoreStrong": "Erős összhang",
    "scoreSolid": "Szilárd összhang",
    "scoreModerate": "Mérsékelt összhang",
    "scoreDifferent": "Eltérő ritmusok",
    "characterAxisFoot": "A jellem tengely tartalmazza a négy pillért",
    "youThem": "Te {self} · Ő {other}",
    "stampInterest": "Érdeklődés",
    "stampPass": "Átugrás",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Az értékeitek közel vannak egymáshoz ({score} a 100-ból).",
    "explainLegacyFuller": "Teljesebb „miért” jelenik meg, miután mindketten kitöltitek a párosító kérdéseket.",
    "explainFaith": "A hit intenzitásotok közel van — hasonló komolysággal követitek Jézust.",
    "explainCharacter": "Ahogyan otthon bánatok az emberekkel, egybeesik — béke, modor és gondoskodás.",
    "explainPurpose": "Hasonlóan értékeltétek saját őszinteségeteket, ami a közös komolyság jele.",
    "explainHome": "Közös érdeklődésetek van a föld, az élelmiszer-termesztés vagy az önellátó otthon iránt.",
    "explainAncestry": "Mindketten hasonló családi háttereket kedveltek. Ez preferencia, nem szűrő — senki nincs emiatt elrejtve.",
    "explainTemperament": "Az érdeklődéseitek és a temperamentumotok átfedésben van.",
    "explainFallback": "Lehetséges egyezés a mindkettőtök által kitöltött válaszokon.",
    "explainOverall": "Összesített affinitás {score} a 100-ból.",
    "affinityAxes": {
      "faith": "Hit intenzitása",
      "character": "Jellem és magatartás",
      "purpose": "Életcél-összhang",
      "home": "Otthon és önellátás",
      "ancestry": "Kulturális és háttér-affinitás",
      "temperament": "Temperamentum-illés"
    },
    "scaleAxes": {
      "loyalty": "Hűség",
      "honesty": "Őszinteség",
      "passion": "Szenvedély",
      "commitment": "Elkötelezettség"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat nem elérhető",
    "unavailableText": "Ez a pár hiányzik, vagy nem tartozik a munkamenetedhez.",
    "backToMatches": "Vissza a párokhoz",
    "backMatches": "← Párok",
    "valuesSubscriber": "Értékek {score} · Előfizető",
    "valuesTrial": "Értékek {score} · Próba",
    "valuesKept": "Értékek {score} · Pár megmaradt",
    "empty": "Köszönj gondosan. A megosztott backendnél az üzenetek mindkét telefonra szinkronizálódnak kölcsönös pár után.",
    "placeholder": "Üzenet {name}…",
    "ariaMessage": "Üzenet",
    "send": "Küldés"
  },
  "billing": {
    "paywallCopy": "Az ingyenes próba után megtarthatod mindazokat, akikkel már párosodtál, és tovább chatelhetsz. Új emberekhez előfizetés kell.",
    "signInToMatch": "Jelentkezz be a párosításhoz.",
    "signInFirst": "Először jelentkezz be.",
    "subscriberUntil": "Előfizető · {date}-ig",
    "renewal": "megújítás",
    "freeTrial": "Ingyenes próba · {days} nap (vége: {date})",
    "soon": "hamarosan",
    "trialEnded": "Próba véget ért · párok és chat nyitva marad",
    "subscribe": "Előfizetés · ${price}/hó",
    "subscribeEarly": "Előfizetés korán · ${price}/hó",
    "activeNote": "Előfizetés aktív — újra láthatsz új embereket.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Mentsd el a helyreállító kódodat",
    "recoveryText": "Írd le most. Csak egyszer jelenik meg. Ha elveszíted a jelszavad, ebben a zárt tesztben ez a kód az egyetlen mód a visszaállításra.",
    "savedContinue": "Elmentettem — folytatás",
    "welcomeBack": "Üdv újra",
    "createAccount": "Hozd létre a fiókodat",
    "intro": "Handle és jelszó. Nem küldünk e-mailt vagy SMS-t. Az azonosítód stabil marad a regisztráción, az ellenőrzésen és a párosításon át.",
    "tabLogin": "Bejelentkezés",
    "tabRegister": "Regisztráció",
    "handle": "Handle",
    "handlePlaceholder": "te@pelda.com vagy rövid handle",
    "passphrase": "Jelszó",
    "passphrasePlaceholder": "Legalább 8 karakter",
    "submitLogin": "Bejelentkezés",
    "submitRegister": "Fiók létrehozása",
    "backWelcome": "Vissza az üdvözléshez"
  },
  "options": {
    "origin": {
      "african": "Afrikai",
      "european": "Európai",
      "asian": "Ázsiai",
      "latino": "Latino / hispán",
      "middleEastern": "Közel-keleti",
      "indigenous": "Őslakos",
      "mixed": "Vegyes",
      "other": "Egyéb",
      "dutch": "Holland",
      "german": "Német",
      "any": "Nyitott — nincs preferencia"
    },
    "interest": {
      "prayer": "Ima",
      "worship": "Dicsőítés",
      "reading": "Olvasás",
      "hiking": "Túrázás",
      "music": "Zene",
      "cooking": "Főzés",
      "farming": "Gazdálkodás / kertészkedés",
      "sports": "Sport",
      "missions": "Misszió",
      "family": "Családi élet",
      "crafts": "Kézművesség",
      "outdoors": "Szabadban"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Igen",
      "no": "Nem"
    },
    "id": {
      "titleEmpty": "Kormányzati igazolvány",
      "titleReady": "Igazolvány kész",
      "hintEmpty": "Útlevél vagy személyi. Készíts élő fotót, vagy válassz képet/PDF-et. Mind a négy sarok látszódjon.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · mentve",
      "previewAlt": "Kormányzati igazolvány előnézet",
      "pdfAria": "PDF dokumentum kiválasztva",
      "takePhoto": "Fotó készítése",
      "retake": "Újra",
      "chooseFile": "Fájl választása",
      "replaceFile": "Fájl cseréje",
      "remove": "Eltávolítás",
      "uploading": "Feltöltés…",
      "cameraTitle": "Fényképezd le az igazolványodat",
      "signIn": "Jelentkezz be az igazolvány feltöltése előtt.",
      "uploadFailed": "A feltöltés sikertelen. Próbáld újra.",
      "badFile": "Ezt a fájlt nem lehetett használni."
    },
    "video": {
      "titleEmpty": "Megerősítő videó",
      "titleLive": "Kamera élő",
      "titleReady": "Videó kész",
      "hintEmpty": "Mondd el a keresztnevedet, és hogy őszintén csatlakozol a UN8-hoz. 5–15 másodperc.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Felvétel",
      "cameraUpload": "Kamera feltöltés",
      "chooseFile": "Fájl választása",
      "startRecording": "Felvétel indítása",
      "cancel": "Mégse",
      "stopSave": "Leállítás és mentés",
      "recordAgain": "Újrafelvétel",
      "replaceFile": "Fájl cseréje",
      "remove": "Eltávolítás",
      "unsupported": "Az élő felvétel itt nem elérhető. Használj kamera feltöltést, vagy válassz fájlt.",
      "permissionDenied": "Kameraengedély megtagadva. Továbbra is feltölthetsz egy rövid videófájlt.",
      "signIn": "Jelentkezz be a videó feltöltése előtt.",
      "uploadFailed": "A feltöltés sikertelen. Próbáld újra.",
      "saveFailed": "A felvételt nem sikerült menteni.",
      "badVideo": "Ezt a videót nem lehetett használni."
    },
    "photos": {
      "count": "{count} / {max} fotó",
      "minimumMet": "Minimum teljesítve",
      "moreRequired": "Még {n} szükséges",
      "listAria": "Ellenőrző fotók",
      "photoAlt": "Fotó {n}",
      "removeAria": "Fotó {n} eltávolítása",
      "camera": "Kamera",
      "takePhoto": "Fotó készítése",
      "chooseFiles": "Fájlok választása",
      "uploading": "Feltöltés…",
      "hint": "A Fotó készítése megnyitja az élő kamerát. A Fájlok választása csak galéria választáshoz. Tiszta arcképek — nincs olyan szűrő, ami elrejti az azonosságot. Max {max}.",
      "cameraTitle": "Készíts fotót magadról",
      "signIn": "Jelentkezz be a fotók feltöltése előtt.",
      "someFailed": "Néhány fotó feltöltése sikertelen. Próbáld újra a sikerteleneket.",
      "addFailed": "Nem sikerült hozzáadni a fotókat."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Bezárás",
      "capture": "Rögzítés",
      "cancel": "Mégse",
      "hint": "Tartsd stabilan. Az élő kamera nyitva marad, amíg rögzítesz.",
      "unavailable": "A kamera nem elérhető ebben a böngészőben. Használd helyette a Fájl választása lehetőséget.",
      "permissionDenied": "Kameraengedély megtagadva vagy nem elérhető. Használd helyette a Fájl választása lehetőséget.",
      "frameFailed": "Ezt a képkockát nem sikerült rögzíteni.",
      "saveFailed": "A fotót nem sikerült menteni."
    },
    "uploadStatus": {
      "uploading": "feltöltés…",
      "failed": "feltöltés sikertelen",
      "savedLocally": "helyben mentve",
      "uploaded": "feltöltve",
      "stored": "tárolva",
      "awaitingUpload": "Feltöltésre vár",
      "localFallbackNote": "{error} A fájl ezen az eszközön mentve van; próbáld újra, amikor a sign végpont él."
    }
  },
  "language": {
    "label": "Nyelv",
    "choose": "Nyelv választása"
  },
  "shell": {
    "back": "Vissza",
    "goBackAria": "Vissza"
  }
} as Messages;
